// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__sn+bq","indicator":"Checkbox_indicator__duVSu","checkIcon":"Checkbox_checkIcon__cUoSk"};